// user initiated, not guaranteed to execute
/** from character to manager */
export const REQUEST_SOLO = "REQUEST_SOLO";
/** from character to manager */
export const REQUEST_CANCEL_SOLO = "REQUEST_CANCEL_SOLO";
/** from button to manager */
export const REQUEST_START_RECORDING = "REQUEST_START_RECORDING";

// notifications for ui updates
/** from manager to character (notification) */
export const SOLO_QUEUED = "SOLO_QUEUED";
/** from manager to progressbar (notification) */
export const RECORDING_COUNT_IN = "RECORDING_COUNT_IN";
/** from manager to progressbar (notification) */
export const RECORDING_STARTED = "RECORDING_STARTED";
/** from manager to progressbar (notification) */
export const RECORDING_ENDED = "RECORDING_ENDED";
/** from manager to progressbar (notification) */
export const RECORDING_UPDATED = "RECORDING_UPDATED";
/** from manager to progressbar (notification) */
export const PLAYHEAD_MOVED = "PLAYHEAD_MOVED";
/** from manager to progressbar (notification) */
export const PLAYBACK_STARTED = "PLAYBACK_STARTED";
/** from manager to progressbar (notification) */
export const PLAYBACK_ENDED = "PLAYBACK_ENDED";

// function calls (imperative aka do the thing now)
/** from manager to character */
export const START_SOLO = "START_SOLO";
/** from manager to character */
export const STOP_SOLO = "STOP_SOLO";
/** from manager to characters */
export const STOP_ALL_SOLOS = "STOP_ALL_SOLOS";

// success callbacks
/** emitted by character */
export const SOLO_STARTED = "SOLO_STARTED";
/** emitted by character */
export const SOLO_ENDED = "SOLO_ENDED";
/** emitted by character */
export const SOLO_STOPPED = "SOLO_STOPPED";

export const SHOW_HINT = "SHOW_HINT";
export const HIDE_HINT = "HIDE_HINT";
export const HIDE_ALL_HINTS = "HIDE_ALL_HINTS";

export const PAUSE_GAME = "PAUSE_GAME";
export const UNPAUSE_GAME = "UNPAUSE_GAME";